(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rd-featured-products"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".NewProductSwiper", {
    slidesPerView: 4,
    spaceBetween: 23,
    navigation: {
      nextEl: ".swiper-button-next-product",
      prevEl: ".swiper-button-prev-product",
    },
    speed: 500,
    breakpoints: {
      320: { slidesPerView: 1.3, spaceBetween: 14 },
      640: { slidesPerView: 1.3, spaceBetween: 14 },
      768: { slidesPerView: 3.3, spaceBetween: 18 },
      1200:{ slidesPerView: 4,   spaceBetween: 23 }
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.new-product-sizes div').forEach(size => {
      size.addEventListener('click', function() {
        const parentBox = this.closest('.new-product-box');
        parentBox.querySelectorAll('.new-product-sizes div').forEach(el => el.classList.remove('active'));
        this.classList.add('active');

        const atcButton = parentBox.querySelector('.add-to-cart-btn');
        if (this.classList.contains('sold-out')) {
          if (window.location.href.includes('indigo')) {
            atcButton.textContent = 'SOLD OUT';
          } else {
            atcButton.textContent = 'Preorder: Mid/Late August $65';
          }
          atcButton.disabled = true;
        } else {
          const variantPrice = this.dataset.price;
          atcButton.textContent = `Add to cart - ${variantPrice}`;
          atcButton.disabled = false;
        }
      });
    });

    let cartActionInProgress = false;
    document.querySelectorAll('.add-to-cart-btn').forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        if (cartActionInProgress) return;
        cartActionInProgress = true;

        const productBox  = this.closest('.new-product-box');
        const activeSize  = productBox.querySelector('.new-product-sizes div.active');
        if (!activeSize) { alert('Please select a valid size'); cartActionInProgress = false; return; }

        const selectedVariant = activeSize.dataset.variantId;
        const quantity        = productBox.querySelector('.product-quantity').value;
        const originalText    = this.textContent;

        this.textContent = 'ADDING...';
        this.disabled = true;

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: selectedVariant, quantity: parseInt(quantity) })
          });

          const cartData = await (await fetch('/cart.js')).json();
          document.querySelectorAll('.cart-count').forEach(el => el.textContent = cartData.item_count);
          if (typeof window.toggleCartDrawer === 'function') window.toggleCartDrawer();
        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.textContent = originalText;
          this.disabled = false;
          cartActionInProgress = false;
        }
      });
    });

    sessionStorage.removeItem('cart_auto_open');
  });

  } catch(e) { console.error(e); }
})();
})();
